import { CAREERRECOMMENDJOB_LIST_TITLE_NM_2PAGE } from '@doda/common/src/constants/seo';
import { formatString } from '@doda/common/src/utils/stringUtil';

/**
 * titleタグ用テキストを生成する
 * @param {number} currentPage 表示中のページ数
 * @param {string} qualificationName 資格名
 * @param {string} optionText 地域や年収などのオプションテキスト
 * @returns {string} titleタグ用テキスト
 */
export const createTitle = (
  currentPage: number,
  qualificationName: string,
  optionText: string
): string => {
  const pagePrefix = currentPage > 1 ? `${currentPage}ページ｜` : '';
  const title = formatString(CAREERRECOMMENDJOB_LIST_TITLE_NM_2PAGE, [
    pagePrefix,
    qualificationName,
    optionText,
  ]);

  return title;
};
